import {connect} from "react-redux";

export default Component => {

	return connect(({Notifications}) => ({Notifications}))(Component);

};
